import { useQuery } from '@tanstack/react-query';
import { httpClient, ROOT_URL } from '../../App';

export const useMetadataNetwork = (currencyId?: number) => {
  const { data } = useQuery(
    ['/api/v1/networks', currencyId],
    async () => {
      const url = currencyId
        ? `${ROOT_URL}/api/v1/networks?_currencyId=${currencyId}`
        : `${ROOT_URL}/api/v1/networks`;
      const response = await httpClient.get(url);
      return response.data;
    },
    {
      enabled: true,
    }
  );

  const metadataNetwork = (data || []).map((item: any) => ({
    value: item.id,
    label: item.name,
  }));

  return { metadataNetwork, dataNetwork: data || [] };
};

